<div class="user-list-dropdown" [container]="'body'" ngbDropdown>
  <button type="button" class="btn btn-user-list dropdown-toggle p-1" ngbDropdownToggle aria-label="Toggle user list">
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.19222 6.5739C9.70067 6.5739 10.9235 5.35106 10.9235 3.84261C10.9235 2.33417 9.70067 1.11133 8.19222 1.11133C6.68378 1.11133 5.46094 2.33417 5.46094 3.84261C5.46094 5.35106 6.68378 6.5739 8.19222 6.5739Z"
        stroke="black"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M1.36328 16.024C1.36328 14.2131 2.08268 12.4763 3.36322 11.1957C4.64376 9.9152 6.38054 9.1958 8.19149 9.1958C10.0024 9.1958 11.7392 9.9152 13.0198 11.1957C14.3003 12.4763 15.0197 14.2131 15.0197 16.024"
        stroke="black"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M14.5391 9.02295C15.3793 9.55988 16.0703 10.3004 16.5478 11.1758C17.0253 12.0513 17.2738 13.0331 17.2703 14.0303"
        stroke="black"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M12.6523 1.56689C13.256 1.56689 13.8349 1.80669 14.2618 2.23354C14.6886 2.66039 14.9284 3.23931 14.9284 3.84297C14.9284 4.44662 14.6886 5.02554 14.2618 5.45239C13.8349 5.87924 13.256 6.11904 12.6523 6.11904"
        stroke="black"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </button>
  <div class="dropdown-menu user-list-dropdown-menu" ngbDropdownMenu>
    <div class="search-container">
      <div class="search-input-wrapper">
        <span class="search-icon">
          <svg width="14" height="14" viewBox="0 0 18 18" fill="none">
            <circle cx="8" cy="8" r="7" stroke="#222" stroke-width="2" />
            <line x1="13" y1="13" x2="17" y2="17" stroke="#222" stroke-width="2" stroke-linecap="round" />
          </svg>
        </span>
        <input
          type="text"
          class="form-control search-input"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Enter Name or email..."
          aria-label="Search users" />
      </div>
    </div>
    <div class="user-list px-1">
      <div class="user-count d-flex align-items-center" [style.gap]="'4px'">
        <span class="user-count-number">{{ filteredUsers.length }}</span>
        <span class="user-count-text text-capitalize">{{ 'Users' | translate }}</span>
      </div>
      <div class="user-item" *ngFor="let user of filteredUsers" ngbDropdownItem>
        <div class="user-avatar">
          <mtm-user-profile-picture
            [username]="user.username"
            [fontSize]="'10px'"
            [height]="24"
            [width]="24"
            [forceLoadProfile]="true"></mtm-user-profile-picture>
        </div>
        <div class="user-info">
          <div class="user-name">
            {{ user.fullName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
